module.exports = __webpack_public_path__ + "img/p1.450fd4a6.jpg";